class ApiContainer {
  add(name, client) {
    this[name] = client;
  }
}

export const apiContainer = new ApiContainer();
